
export const SUMMARY_TITLE = "Summary"

export const DASHBOARD_TOOLBAR_TITLE = "Dashboard"
export const REFRESH_TITLE = "Refresh Dashboard"
export const RETRIEVE_USER_TABLE_FILTER_FAILED ="retrieve user table filter information failed"
export const SERVER_FAILED_ERROR_MESSAGE = "Server Failed";
export const FIND_INVOICE_BY_INVOICE_NUMBER_ERROR_MESSAGE = "Find invoice by invoice number failed";
export const ACCOUNT_EXPIRE_ERROR_MESSAGE = "Your company account is expired. Please ask your Master Admin to activate a new license key";



export const PENDING_LIST_HEAD_CELLS = [
    // { id: 'tagId', label: 'ID', align: "left" },
    { id: 'picture', label: 'Picture', align: "left" },
    { id: 'firstName', label: 'First Name', align: "left"},
    { id: 'lastName', label: 'Last Name', align: "left"},
    { id: 'signInTime', label: 'Sign In', align: "left"},
    // { id: 'ticket', label: 'Ticket', align: "left"},
]


export const GIVEN_POINTS_HEAD_CELLS = [
    // { id: 'tagId', label: 'ID', align: "left" },
    { id: 'picture', label: 'Picture', align: "left" },
    { id: 'firstName', label: 'First Name', align: "left"},
    { id: 'lastName', label: 'Last Name', align: "left"},
    { id: 'finalSignIn', label: 'Sign In', align: "left"},
    { id: 'ticket', label: 'Machine', align: "left"},
    { id: 'signInTime', label: 'Time At Pending', align: "left"},
]

// Surfaced as an extra column only for senior roles (see
// DashboardFinal.canSeePoints). Rendered right-aligned because the value
// is numeric, and the dashboard's default sort snaps to this column
// descending so the biggest point balances float to the top.
export const POINTS_COLUMN = { id: 'points', label: 'Points', align: 'right' };

// Roles that should see the Points column on both dashboard tables.
export const POINTS_VISIBLE_ROLES = [
    'ROLE_OWNER',
    'ROLE_MASTER_ADMIN',
    'ROLE_MANAGER',
    'ROLE_SUPERVISOR',
];